import { useCallback, useEffect } from 'react';
export const useVisualViewport = ({ height, width } = {
    height: '--viewport-height',
    width: '--viewport-width',
}) => {
    const updateViewport = useCallback(() => {
        if (typeof window !== 'undefined' &&
            typeof document.documentElement !== 'undefined') {
            const { innerHeight, innerWidth, visualViewport } = window;
            const h = visualViewport ? visualViewport.height : innerHeight;
            const w = visualViewport ? visualViewport.width : innerWidth;
            document.documentElement.style.setProperty(height, `${h}px`);
            document.documentElement.style.setProperty(width, `${w}px`);
        }
    }, [height, width]);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeHandler = () => requestAnimationFrame(updateViewport);
            const { visualViewport } = window;
            resizeHandler();
            if (visualViewport) {
                visualViewport.addEventListener('resize', resizeHandler);
                return () => {
                    visualViewport.removeEventListener('resize', resizeHandler);
                };
            }
            window.addEventListener('resize', resizeHandler);
            return () => {
                window.removeEventListener('resize', resizeHandler);
            };
        }
        return undefined;
    }, [updateViewport]);
    return { height, width };
};
//# sourceMappingURL=useVisualViewport.js.map